import {
  PatientNotificationPreference,
  PatientNotificationPreferenceControllerApi,
} from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

export const useUpdateNotificationPreferences = () =>
  useMutationWithLoading(
    async (params: {
      patientUuid: string;
      preferences: PatientNotificationPreference[];
    }) =>
      new PatientNotificationPreferenceControllerApi(
        getConfigObject()
      ).updatePreferences(params.patientUuid, params.preferences)
  );
